import { H4, Text } from 'platform-components/common';
import React from 'react';

import './spec-course-lesson-view__section-title.scss';

interface Props {
    id: string;
    values?: Record<string, any>;
}

export const SpecCourseLessonViewSectionTitle = React.memo(({ id, values }: Props) => {
    return (
        <div className="spec-course-lesson-view__section-title">
            <H4 id={id} values={values} weight={Text.WEIGHT.L} />
        </div>
    );
});
